import { render, staticRenderFns } from "./modelTopicDetail.vue?vue&type=template&id=da917464&scoped=true"
import script from "./modelTopicDetail.vue?vue&type=script&lang=js"
export * from "./modelTopicDetail.vue?vue&type=script&lang=js"
import style0 from "./modelTopicDetail.vue?vue&type=style&index=0&id=da917464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da917464",
  null
  
)

export default component.exports